<template>
  <div class="lxm-login-reg-source-tip"
       :style="style"
       v-html="content">
  </div>
</template>

<style lang="stylus" scoped>
  @import '../../styles/index.styl'
  .lxm-login-reg-source-tip
    margin-bottom: spacing-big
</style>

<script>
  export default {
    computed: {
      content () {
        if (window.X && window.X['reg_source'] && window.X['reg_source']['reg_text']) {
          return window.X['reg_source']['reg_text']
        } else {
          return null
        }
      },
      style () {
        if (this.content) {
          return {}
        } else {
          return { display: 'none' }
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// RegSourceTip.vue?6a8ecbe2